<template>
    <div class="row">
        <div class="cell" id="id">{{item.id}}</div>
        <div class="cell">
            <h4>{{ item.name }}</h4>

                <ul>
                    <li v-for="other in item.other">{{ other }}</li>
                </ul>

        </div>
        <div class="cell">
            <h4>{{ item.percentage}}% Beteligung </h4>
            <h6>{{ item.cost }}</h6>
        </div>
    </div>
</template>

<style lang="scss">
    @import '../../assets/css/style';
    .row {
        margin:0;
        padding: 12px 0;
        border-bottom:1px solid $line_color;
        .cell {
            font-size: 1.6rem;

            &:nth-of-type(1) {
                width: 4%;
                color: $label-color;
                font-weight: 500;
                padding:0px;
            }

            &:nth-of-type(2),
            &:nth-of-type(3) {
                padding-top: 2px;
                padding-left: 5px;
                h4 {
                    color: $font-color_dark;
                    font-weight: 600;
                    margin-bottom: 0px;
                }
            }

            &:nth-of-type(2) {

                width: 61%;
                ul{
                    li{
                        &:first-of-type{
                            list-style: none;
                            margin-right:7px;

                        }
                        float: left;
                        &:not(:first-of-type){
                            margin-left:10px;
                        }
                    }
                }
            }

            &:nth-of-type(3){
                text-align: right;
                h4{
                    font-weight: 600;
                }
            }

            .h6,
            ul {
                padding:0;
                li{
                    font-size: 1.3rem;
                    color: $button-outline-color;
                }
            }
        }
    }
</style>

<script>
    export default {
        props: ['item'],
        data() {
            return {
                quantity: 0
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/neue_beteiligung/Item.vue